import React, { useState } from "react";
import EdModal from "../../../generic/edModal";
import Loader from "../../../generic/loader";
import TocDropdown from "../../../generic/tocDropdown";
import {
  getbankBranch,
  getbankCities,
  getDistinctBanklist,
} from "../../../service/generic/otherApi";

export const BankIfscpop = (props: any) => {
  const [ifscPop, setIfscPop] = useState<any>(true);
  const [finalPopIfsc, setFinalPopIfsc] = useState<any>(false);
  const [listOfIfsc, setlistOfIfsc] = useState<any>();
  const [ifscBankForm, setifscBankForm] = useState<any>({
    ifsc: "",
    micr: "",
    city: "",
    branch: "",
    bankName: "",
  });
  const [bankDetails, setBankDetails] = useState<any>({
    bankName: [],
    bankBranch: [],
    bankCity: [],
  });
  const [selectedBankList, setSelectedBankList] = useState<any>({
    bankName: "",
    bankCity: "",
    bankBranch: "",
  });
  //const [loader, setLoader] = useState(true);
  //const [ifscloader, setifscloader] = useState(false);
  React.useEffect(() => {
    const position = window.pageYOffset;
    if (position > 0) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
    getBankList();
  }, []);
  const openSRErrorPopup = () => {
    props.setLoader(false);
    props.onSubmit("bankModification", {
      headerText:
        "There was some problem in raising service request. Please try again later.",
    });
  };
  const getBankList = async () => {
    props.setLoader(true);
    let response = await getDistinctBanklist();
    if (response) {
      let bankList = response.data.banknames.map((list: any) => {
        return { value: list.bankname, display: list.bankname };
      });
      bankList.sort((a: any, b: any) => (a.display > b.display ? 1 : -1));
      if (bankList) {
        setBankDetails({ ...bankDetails, bankName: bankList });
        props.setLoader(false);
      } else openSRErrorPopup();
    } else {
      openSRErrorPopup();
    }
  };
  const onchange = async (name: string, val: any) => {
    props.setLoader(true);
    if (name === "bankName") {
      setSelectedBankList({
        ...selectedBankList,
        bankName: val,
        bankBranch: "",
        bankCity: "",
      });
      setBankDetails({
        ...bankDetails,
        bankBranch: [],
        bankCity: [],
      });
      let response = await getbankCities({ bankname: val });
      if (response && response.data.bankcities) {
        response.data.bankcities.sort((a: any, b: any) =>
          a.bankcity > b.bankcity ? 1 : -1
        );
        let list_of_city = response.data.bankcities.map((list: any) => {
          return { value: list.bankcity, display: list.bankcity };
        });
        setBankDetails({ ...bankDetails, bankCity: list_of_city });
        props.setLoader(false);
      }
    } else if (name === "bankCity") {
      setBankDetails({
        ...bankDetails,
        bankBranch: [],
      });

      setSelectedBankList({
        ...selectedBankList,
        bankCity: val,
        bankBranch: "",
      });
      let res = await getbankBranch({
        bankcity: val,
        bankname: selectedBankList.bankName,
      });
      props.setLoader(false);
      if (res && res.data.bankbranches) {
        res.data.bankbranches.sort((a: any, b: any) =>
          a.branch > b.branch ? 1 : -1
        );
        let list_of_branch = res.data.bankbranches.map((list: any) => {
          return {
            value: list.branch,
            display: list.branch,
            ifsc: list.ifsccode,
            micr: list.micr,
          };
        });
        setlistOfIfsc([...list_of_branch]);
        setBankDetails({ ...bankDetails, bankBranch: list_of_branch });
      }
    } else if (name === "bankBranch") {
      setSelectedBankList({ ...selectedBankList, bankBranch: val });
      props.setLoader(false);
    } else {
      openSRErrorPopup();
    }
  };

  const onsearch = () => {
    if (
      selectedBankList.bankName &&
      selectedBankList.bankCity &&
      selectedBankList.bankBranch
    ) {
      let selectedIfsc = listOfIfsc.find((list: any) => {
        if (list.value === selectedBankList.bankBranch) {
          return list;
        }
      });
      setifscBankForm({
        ...ifscBankForm,
        ifsc: selectedIfsc.ifsc,
        micr: selectedIfsc.micr,
        branch: selectedBankList.bankBranch,
        city: selectedBankList.bankCity,
        bankName: selectedBankList.bankName,
      });
      setIfscPop(false);
      setFinalPopIfsc(true);
    }
  };
  const ifscpopup = () => {
    return (
      <>
        {/* {ifscloader && (
          <div className="innerLoader">
            <div
              style={{
                textAlign: "center",
                paddingTop: "50px",
                paddingBottom: "50px",
              }}
            >
              <Loader size={50} color="blue"></Loader>
            </div>
          </div>
        )} */}

        <div
          className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup consent_popup innerModal"
          style={{ pointerEvents: props.loader ? "none" : "all" }}
        >
          <div className="modal-content">
            <div className="modal-body scrollableModal" id="custom_scrollBar">
              <div>
                <div className="finalScreen consentPopup searchCodeIfsc">
                  <div className="">
                    <div>
                      <h2 className="head">Search IFSC Code</h2>
                      <span
                        role="button"
                        title="Close"
                        className="cancel"
                        onClick={() => {
                          setIfscPop(false);
                          props.searchIfsc(false);
                        }}
                      >
                        <i className="edel-icon-close"></i>
                      </span>
                    </div>
                  </div>
                  <div id="search_ifsc">
                    <div className="search_ifsc_wrap">
                      {" "}
                      <label className="input-label">Bank Name</label>
                      <div className="italic-placeholder">
                        <TocDropdown
                          selectedValue={
                            selectedBankList.bankName
                              ? selectedBankList.bankName
                              : ""
                          }
                          dropdownOptions={
                            bankDetails.bankName.length > 0
                              ? bankDetails.bankName
                              : []
                          }
                          onSelect={(val: any) => {
                            onchange("bankName", val);
                          }}
                          disabled={props.loader}
                          isSearchable={!props.loader ? true : false}
                        />
                      </div>
                    </div>
                    <div className="search_ifsc_wrap">
                      {" "}
                      <label className="input-label">City</label>
                      <div className="italic-placeholder">
                        <TocDropdown
                          selectedValue={
                            selectedBankList.bankCity
                              ? selectedBankList.bankCity
                              : ""
                          }
                          dropdownOptions={
                            bankDetails.bankCity ? bankDetails.bankCity : []
                          }
                          onSelect={(val: any) => {
                            onchange("bankCity", val);
                          }}
                          disabled={props.loader}
                          isSearchable={!props.loader ? true : false}
                        />
                      </div>
                    </div>
                    <div className="search_ifsc_wrap">
                      {" "}
                      <label className="input-label">Branch</label>
                      <div className="italic-placeholder">
                        <TocDropdown
                          selectedValue={
                            selectedBankList.bankBranch
                              ? selectedBankList.bankBranch
                              : ""
                          }
                          dropdownOptions={
                            bankDetails.bankBranch ? bankDetails.bankBranch : []
                          }
                          onSelect={(val: any) => {
                            onchange("bankBranch", val);
                          }}
                          disabled={props.loader}
                          isSearchable={!props.loader ? true : false}
                        />
                      </div>
                    </div>
                    <div className="search_ifsc_wrap search_ifsc_wrap--btn">
                      <button
                        type="button"
                        className="btn btn-blue login-btn"
                        disabled={
                          !(
                            selectedBankList.bankName &&
                            selectedBankList.bankCity &&
                            selectedBankList.bankBranch
                          )
                        }
                        onClick={() => {
                          onsearch();
                        }}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const innerPopup = () => {
    return (
      <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup consent_popup innerModal innerModal--box">
        <div className="modal-content">
          <div className="modal-body scrollableModal" id="custom_scrollBar">
            <div>
              <div className="finalScreen consentPopup searchCodeIfsc">
                <div className="">
                  <div>
                    <h2 className="head">Search IFSC Code</h2>
                    <a
                      role="button"
                      href="#"
                      title="Close"
                      className="cancel"
                      onClick={() => {
                        setFinalPopIfsc(false);
                      }}
                    >
                      <i className="edel-icon-close"></i>
                    </a>
                  </div>
                </div>
                <div className="blue_box">
                  <p className="field-head text-center">
                    IFSC: <span>{ifscBankForm.ifsc}</span>
                  </p>
                  <p className="field-head text-center grey_text">
                    {selectedBankList.bankName}
                  </p>
                  <p className="field-head text-center grey_text">
                    {selectedBankList.bankBranch}
                  </p>
                  <div className="display-flex btn_links">
                    <div>
                      <button
                        className="ed_button button submit_btn"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setIfscPop(true);
                          setFinalPopIfsc(false);
                          setSelectedBankList({
                            ...selectedBankList,
                            bankName: "",
                            bankCity: "",
                            bankBranch: "",
                          });
                        }}
                      >
                        Search Another
                      </button>
                    </div>
                    <div>
                      <a
                        className="ed_button button submit_btn active"
                        href=""
                        onClick={(e: any) => {
                          e.preventDefault();
                          setIfscPop(false);
                          setFinalPopIfsc(false);
                          props.updateBankDetails(ifscBankForm);
                        }}
                      >
                        Select
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <EdModal show={ifscPop} close={() => {}} children={ifscpopup()} />
      <EdModal show={finalPopIfsc} close={() => {}} children={innerPopup()} />
    </>
  );
};
